export default __webpack_public_path__ + "static/media/4692.854bd8a7.png";